<div [matMenuTriggerFor]="menu" class="menu" style="margin: 0.5em">
  <span>
    {{ $safeNavigationMigration(range?.from) | date: "dd/MM/yyyy HH:mm" }} / {{
    $safeNavigationMigration(range?.to) | date: "dd/MM/yyyy HH:mm" }}
  </span>
  <button mat-icon-button>
    <mat-icon>date_range</mat-icon>
  </button>
</div>

<!-- Range Picker -->
<mat-menu #menu="matMenu">
  <!-- Lazy: sin matMenuContent los 2 calendarios existen (y se chequean en
       cada ciclo) aunque el menú esté cerrado. -->
  <ng-template matMenuContent>
    <div class="container" (click)="$event.stopPropagation();">
      <!-- Calendarios -->
      <div class="calendar-container">
        <div>
          <mat-calendar
            #fromCalendar
            class="from-calendar"
            [(selected)]="from"
            (selectedChange)="cambioFrom($event);"
            [startAt]="from"
            [dateClass]="$any(dateClass)"
          ></mat-calendar>
        </div>

        <mat-calendar
          #toCalendar
          class="to-calendar"
          [minDate]="from"
          [(selected)]="to"
          (selectedChange)="cambioTo($event)"
          [startAt]="to"
          [dateClass]="$any(dateClass)"
        ></mat-calendar>
      </div>

      <!-- Horas -->
      <div class="calendar-container">
        <div>
          <mat-form-field class="timepicker form-transparente">
            <input
              matInput
              name="selected_timeFrom"
              [format]="24"
              [ngxMatTimepicker]="timeFrom"
              readonly
              [(ngModel)]="fromHour"
            />
            <mat-icon matSuffix (click)="timeFrom.open()">watch_later</mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker
            color="accent"
            #timeFrom
            (timeChanged)="cambioHoraFrom($event)"
          ></ngx-mat-timepicker>
        </div>

        <div>
          <mat-form-field class="timepicker form-transparente">
            <input
              matInput
              name="selected_timeTo"
              [format]="24"
              [ngxMatTimepicker]="timeTo"
              readonly
              [(ngModel)]="toHour"
            />
            <mat-icon matSuffix (click)="timeTo.open()">watch_later</mat-icon>
          </mat-form-field>
          <ngx-mat-timepicker
            color="accent"
            #timeTo
            (timeChanged)="cambioHoraTo($event)"
          ></ngx-mat-timepicker>
        </div>
      </div>

      <!-- Presets -->
      <div class="presets-container">
        @for (preset of presets; track preset) {
        <button
          mat-stroked-button
          color="accent"
          (click)="cambioPreset(preset)"
        >
          {{ preset.label }}
        </button>
        }
      </div>

      <!-- Aplicar / Cancelar -->
      <div class="actions-container">
        <button
          mat-flat-button
          color="accent"
          (click)="aplicar()"
          [disabled]="!from || !to"
        >
          Aplicar
        </button>

        <button mat-flat-button (click)="cancelar()">Cancelar</button>
      </div>
    </div>
  </ng-template>
</mat-menu>
